import { QueryConstraint, where } from "firebase/firestore";
export type queryProps = {
  item: queryItem[];
};
export type queryItem = {
  name: string;
  value: string | number | string[] | boolean;
  //ここは随時増やす（公式参照 https://firebase.google.com/docs/firestore/query-data/queries?hl=ja）
  operator: "==" | "<" | "in";
};

export const setQuery = ( item: queryItem[]) => {
  let queryList: QueryConstraint[] = [];
  item.map((i) =>  queryList.push(where(i.name, i.operator, i.value)));
  return queryList;
};
